import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteDefinition } from './types';

const PracticeSession = lazy(() => import('../pages/PracticeSession'));
const FlashcardPractice = lazy(() => import('../pages/FlashcardPractice'));
const IrabPractice = lazy(() => import('../pages/IrabPractice'));
const WaznPractice = lazy(() => import('../pages/WaznPractice'));
const VerbConjugationDrills = lazy(() => import('../pages/VerbConjugationDrills'));
const BrokenPlurals = lazy(() => import('../pages/BrokenPlurals'));

export const practiceRoutes: RouteDefinition[] = [
  { path: '/practice', element: <PracticeSession />, guard: 'onboarding' },
  { path: '/practice/flashcards', element: <FlashcardPractice />, guard: 'onboarding' },
  { path: '/practice/irab', element: <IrabPractice />, guard: 'onboarding' },
  { path: '/practice/wazn', element: <WaznPractice />, guard: 'onboarding' },
  { path: '/practice/conjugation', element: <VerbConjugationDrills />, guard: 'onboarding' },
  { path: '/practice/plurals', element: <BrokenPlurals />, guard: 'onboarding' },
  // Redirect old smart-review URL to new tab route
  { path: '/smart-review', element: <Navigate to="/review" replace /> },
];
